import React from 'react'
import { AppBar, AppBarProps } from 'react-admin'
import MyUserMenu from './UserMenu'

const MyAppBar = (props: AppBarProps): JSX.Element => <AppBar {...props} userMenu={<MyUserMenu />} />

export default MyAppBar
